const Constantes = {
    backend_URL: "https://pwa-mini-br-backend.vercel.app"
};

export default Constantes;